import React, { Fragment, useContext, useState, useEffect } from 'react';
import { Container, Row, Col } from 'reactstrap';
import { Breadcrumbs } from '../../../../AbstractElements';
import CustomizerContext from '../../../../_helper/Customizer';
import { useNavigate } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { OrganisationTypeApi } from '../../../../api';
import { toast } from 'react-toastify';
import CardRibbonWithForm from '../../../Common/Component/CardRibbonWithForm';
import useAxiosPrivate from '../../../../Hooks/useAxiosPrivate';
import { base_form_fields, primary_field } from '../../../../Data/FormField/PublicData';

const OrganisationTypeNew = () => {
  const history = useNavigate();
  const { layoutURL } = useContext(CustomizerContext);
  const axiosPrivate = useAxiosPrivate()
  const lists = `${process.env.PUBLIC_URL}/organisations/types/${layoutURL}`;

  const { formState: { errors },} = useForm(); 

  const [formFields, setFormFields] = useState(base_form_fields);
  const [isNewFieldAdded, setIsNewFieldAdded] = useState(false);

  useEffect(() => {
    if (!isNewFieldAdded) {
      const indexOfName = formFields.findIndex((formField) => formField.id === 'is_active');

      const updatedFields = [...formFields];
      updatedFields.splice(indexOfName + 1, 0, primary_field);

      setFormFields(updatedFields);
      setIsNewFieldAdded(true);
    }
  }, [formFields, isNewFieldAdded, primary_field]);

  const addNewRecord =  async (newRecord) => {
      if (newRecord === '') { 
        errors.showMessages();
      }

      const newRecordTemp = {
          name: newRecord.name,
          description: newRecord.description,
          is_active: newRecord.is_active,
          is_primary: newRecord.is_primary,
      };

      try {
          await axiosPrivate.post(OrganisationTypeApi, newRecordTemp).then((resp) => {
            toast.success(`${resp.data.name} is successfully added.`)
            history(lists);
          });
      } catch (error) {
        if (error.response && error.response.status === 422) {
            toast.error('Validation Errors');
          } else if (error.response && error.response.status === 400) {
            toast.error(error.response.data.detail);
          } else {
            toast.error('Form submission error');
          }
        throw error;
    }   
  };


  return (
    <Fragment>
      <Breadcrumbs parent="Organisations" title="New Organisation Type" mainTitle="New Organisation Type" />
      <Container fluid={true}>
        <Row>
          <Col sm='10'>
            <CardRibbonWithForm formFields={formFields} onSubmit={addNewRecord} ribbonUrl={lists} />
          </Col>
        </Row>
      </Container>
    </Fragment>
  );
};

export default OrganisationTypeNew;